<template>
    <transition :css="false" @appear="intro" @enter="intro" @leave="outro">
        <div class="Home">
            <!-- TEXT-BARREL -->
            <text-barrel
                v-show="textBarrelVisible"
                :text="chapterNameList"
            ></text-barrel>
            <!-- DESCRIPTION -->
            <div class="Home-container">
                <text-transition v-show="descriptionVisible">
                    <p class="Home-copy" ref="copy">
                        {{data.intro.description[introDescriptionIndex]}}
                    </p>
                </text-transition>
            </div>
            <!-- INDICATION -->
            <div class="Home-container">
                <div class="Home-indication">
                    <line-icon
                        v-show="indicationVisible"
                        class="Home-audioIcon"
                        :width="lineIcons.headphones.width"
                        :height="lineIcons.headphones.height"
                        :d="lineIcons.headphones.d"
                    ></line-icon>
                    <text-transition v-show="indicationVisible">
                        <div class="small">
                            {{data.intro.indication}}
                        </div>
                    </text-transition>
                </div>
            </div>
            <!-- INTRO-LOGO -->
            <intro-logo v-show="introLogoVisible"></intro-logo>
            <!-- SKIP-INTRO -->
            <transition name="fade">
                <!--
                Transitions don't work with router-link so a div container is
                necessary
                -->
                <div v-show="skipIntroVisible" class="Home-skip">
                    <router-link :to="{ name: 'chapter' }">
                        <small>{{ data.intro.skip }}</small>
                    </router-link>
                </div>
            </transition>
            <!-- CONTINUE -->
            <div class="Home-continue">
                <icon-bttn
                    v-show="continueVisible"
                    :to="{ name: 'chapter' }"
                    :icon-width="lineIcons.continue.width"
                    :icon-height="lineIcons.continue.height"
                    :icon-path="lineIcons.continue.d"
                >
                    {{data.intro.continue}}
                </icon-bttn>
            </div>
        </div>
    </transition>
</template>

<script>
    import ChapterUtils from '../mixins/ChapterUtils'
    import IntroLogo from '../components/IntroLogo'
    import TextBarrel from '../components/TextBarrel'
    import LineIcon from '../components/LineIcon'
    import IconBttn from '../components/IconBttn'
    import TextTransition from '../transitions/TextTransition'

    export default {
        name: 'Home',
        mixins: [
            ChapterUtils,
        ],
        components: {
            IntroLogo,
            TextBarrel,
            LineIcon,
            IconBttn,
            TextTransition,
        },
        data() {
            return {
                timeline: null,
                skipIntroVisible: false,
                introLogoVisible: false,
                textBarrelVisible: false,
                indicationVisible: false,
                descriptionVisible: false,
                continueVisible: false,
            }
        },
        mounted() {
            this.updateDescriptionIndex()
        },
        methods: {
            intro($el, done) {
                this.setBackgroundVisible(false);
                const tl = new TimelineLite()
                tl.delay(1)
                tl.call(() => {
                    this.skipIntroVisible = true
                    this.indicationVisible = true
                }, [], this, 0)
                tl.call(() => {
                    this.indicationVisible = false
                    this.textBarrelVisible = true
                    this.introLogoVisible = true
                }, [], this, '+=4')
                tl.call(() => {
                    this.introLogoVisible = false
                }, [], this, '+=4')
                tl.call(() => {
                    this.descriptionVisible = true
                    this.continueVisible = true
                }, [], this, '+=0.2')
                tl.call(() => done, [], this, '+=1')
                this.timeline = tl
            },
            outro($el, done) {
                this.setBackgroundVisible(true);
                // Destroy timeline
                this.timeline.kill()
                this.timeline = null
                // Hide all components
                this.introLogoVisible = false
                this.textBarrelVisible = false
                this.indicationVisible = false
                this.descriptionVisible = false
                this.skipIntroVisible = false
                this.continueVisible = false
                // Delay done callback so all components have time to anim-out
                TweenLite.delayedCall(0.75, done)
            },
            updateDescriptionIndex() {
                const {data, introDescriptionIndex} = this
                let index = introDescriptionIndex + 1
                if (index === data.intro.description.length) {
                    index = 0
                }
                localStorage.setItem('intro-desc-index', index)
            },
        },
        computed: {
            lineIcons() {
                const {$store} = this
                return $store.getters.data.lineIcons
            },
            introDescriptionIndex() {
                if (localStorage.hasOwnProperty('intro-desc-index')) {
                    let index = localStorage.getItem('intro-desc-index')
                    return parseInt(index)
                }
                return 0
            },
        },
    }
</script>

<style src="styles/views/Home.styl" lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/views/Home.vue